import { render, staticRenderFns } from "./FieldCustomerDeliveryName.vue?vue&type=template&id=2c4127a5&"
import script from "./FieldCustomerDeliveryName.vue?vue&type=script&lang=js&"
export * from "./FieldCustomerDeliveryName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports